import { forwardRef, Select, SelectItem } from '@heroui/react'
import { useSMSNumbers } from 'components/Dashboard/SMS/hooks/useSMSNumbers'

const SMSNumbersSelect = forwardRef(({ value, ...props }, ref) => {
  const { data: { numbers: smsNumbers } = { numbers: [] }, isLoading: smsNumbersLoading } = useSMSNumbers({ enabled: true })
  return (
    <Select
      isLoading={smsNumbersLoading}
      labelPlacement="outside"
      variant="bordered"
      radius="sm"
      isVirtualized
      placeholder="Select one of your SMS-configured numbers"
      description="If you don't select a number, we'll use one at random."
      label="From Number"
      selectedKeys={value && [value]}
      {...props}
      ref={ref}
    >
      {smsNumbers?.map(number => (
        <SelectItem key={number.phone_number}>
          {number.phone_number}
        </SelectItem>
      ))}
    </Select>
  )
})

export default SMSNumbersSelect
